import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import debounce from "lodash.debounce";
import leftArrow from "../../Assets/HourlyData/leftArrow.svg";
import SearchLocation from "../../Assets/ManageLocations/SearchLocation.jsx";
import Add_location from "../../Assets/ManageLocations/Add_location.jsx";

import FormattedWeather from "../../api/FormattedWeather";
import logoAndTitleFunction from "../../AllFunctions/logoAndTitleFunction";
import { useDispatch, useSelector } from "react-redux";
import { getFormattedDateTime } from "../../AllFunctions/formattedDateAndTime";
import {
  setLatitude,
  setLocationInput,
  setLongitude,
  setPlaceName,
  setLoading,
  setSuggestions,
  setMappedNewLocations,
  setError,
  setFormattedWeather,
  setGeoLocationOn,
} from "../../ReduxStore/App/DashBoard/dashboardSlice";
import DeleteBox from "../../Assets/ManageLocations/DeleteBox.jsx";
import Modal from "react-modal";
import MetroPoliticianCities from "./MetroPoliticianCities";
import toast, { Toaster } from "react-hot-toast";
import { Tooltip } from "react-tooltip";
Modal.setAppElement("#root");

const customStyles = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    backdropFilter: "blur(4px)",
    zIndex: 1000,
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    padding: "0",
    border: "none",
    background: "transparent",
    width: "fit-content",
    maxWidth: "90%",
    minWidth: "320px",
  },
};

const ManageLocations = () => {
  const subtitleRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedInfo, setSelectedInfo] = useState({});
  const [selectedLocation, setSelectedLocation] = useState("");
  const suggestionsRef = useRef(null);

  const {
    locationInput,
    suggestions,
    loading,
    error,
    mappedNewLocations,

    theme,
  } = useSelector((store) => store.dashboard);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const openModal = (location) => {
    setIsModalOpen(!isModalOpen);
    setSelectedLocation(location);
  };

  const closeModal = () => {
    setIsModalOpen(!isModalOpen);
    // setSelectedLocation(null); // Reset the state when modal is closed
  };

  const handleCity = (city) => {

    toast.success("Location Updated.");

    // First update the coordinates in Redux
    dispatch(setLongitude(city.longitude));
    dispatch(setLatitude(city.latitude));
    dispatch(setPlaceName(city.cityDBName, city.distDBName));
    // Disable geolocation to prevent it from overriding manually selected location
    dispatch(setGeoLocationOn(false));

    // Then fetch and update weather data
    setTimeout(async () => {
      try {
        let data = await FormattedWeather(city.latitude, city.longitude);
        if (data && data['Forecast data']) {
          dispatch(setFormattedWeather(data['Forecast data']));
        }
        navigate(-1);
      } catch (error) {
        toast.error("Could not fetch weather data");
        console.error("Could not fetch weather data:", error);
        navigate(-1);
      }
    }, 1000);
  };

  async function getWeatherDataAccToLocation(lat, lon) {
    try {
      let response = await FormattedWeather(lat, lon);
      return response[`Forecast data`];
    } catch (error) {
      toast.error("Could not fetch weather data");
      console.log("Could not fetch weather data:", error);
    }
  }

  const debouncedFetchSuggestions = debounce(async (value) => {
    dispatch(setLoading(true));
    dispatch(setError(null));
    try {
      let solrUrl = process.env.REACT_APP_SOLR_URL;
      let key = process.env.REACT_APP_SOLR_KEY;
      const response = await fetch(
        `${solrUrl}?q=(village:${value}~* OR state:${value}~* OR district:${value}~*)&rows=8`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Basic ${key}`,
          },
        }
      );
      if (!response.ok) {
        dispatch(setError(`HTTP error! status: ${response.status}`));
      }
      const data = await response.json();
      dispatch(setSuggestions(data.response.docs || []));
    } catch (err) {
      dispatch(setError(err.message));
    } finally {
      dispatch(setLoading(false));
    }
  }, 300);

  const handleInputChange = (e) => {
    const value = e.target.value;
    dispatch(setLocationInput(value));
    // setInput(value);
    if (value.length >= 1) {
      debouncedFetchSuggestions(value);
    } else {
      dispatch(setSuggestions([]));
      dispatch(setError(null));
    }
  };

  const addNewLocation = async (village, district, latitude, longitude) => {
    dispatch(setLocationInput(village, district));
    dispatch(setSuggestions([]));
  };
  useEffect(() => {
    return () => {
      debouncedFetchSuggestions.cancel();
    };
  }, []);

  const handleBackNavigation = () => navigate(-1);
  const handleRemoveNewLocations = (index) => {
    toast.success("Removed Location Successfully ");
    let updatedArr = mappedNewLocations.filter(
      (location, mainIndex) => mainIndex !== index
    );
    dispatch(setMappedNewLocations(updatedArr));
  };
  // ============================ on clicking continue <button></button>
  const addCurrentLocation = async (newLocation) => {
    // First update the coordinates in Redux
    dispatch(setLongitude(newLocation.long));
    dispatch(setLatitude(newLocation.lat));
    dispatch(setPlaceName(newLocation.vill));
    // Disable geolocation to prevent it from overriding manually selected location
    dispatch(setGeoLocationOn(false));

    // Then fetch and update weather data
    try {
      let data = await FormattedWeather(newLocation.lat, newLocation.long);
      if (data && data['Forecast data']) {
        dispatch(setFormattedWeather(data['Forecast data']));
      }
    } catch (error) {
      toast.error("Could not fetch weather data");
      console.error("Could not fetch weather data:", error);
    }

    // Highlight the selected location
    // dispatch(setHighlightedIndex(index));
    navigate(-1);
    closeModal();
  };

  // const confirmedLocation = (newLocation) => {
  //   dispatch(setLongitude(newLocation.long));
  //   dispatch(setLatitude(newLocation.lat));
  //   dispatch(setPlaceName(newLocation.vill, newLocation.dist));

  // };
  const addFavorateCity = async ({
    village,
    district,
    latitude,
    longitude,
  }) => {
    let data = await getWeatherDataAccToLocation(latitude, longitude);
    let timeAndDate = getFormattedDateTime();

    if (!data) {
      return;
    }
    let dataTitle = logoAndTitleFunction(data[0]).title;
    let newLocationObject = {
      vill: village,
      dist: district,
      lat: latitude,
      long: longitude,
      data: data[0].Tmax,
      title: dataTitle,
      date: timeAndDate.date,
      time: timeAndDate.time,
    };

    // Create a unique key for the new location object to check for duplicates
    const newLocationKey = `${newLocationObject.vill}-${newLocationObject.dist}`;

    // Check if the location already exists by comparing the key
    const existingIndex = mappedNewLocations
      .map((location) => `${location.vill}-${location.dist}`)
      .indexOf(newLocationKey);

    if (existingIndex === -1) {
      // If the location does not exist, add it
      dispatch(
        setMappedNewLocations([...mappedNewLocations, newLocationObject])
      );
      toast.success("Added Location Successfully ");
    } else {
      // If the location exists, alert the user
      // alert("This location is already added.");
      toast.error(
        "This location is already added. Please Add another location. "
      );
    }

    dispatch(setLocationInput(""));
    setSelectedInfo({});
    //  dispatch(setSelectedInfo({}))
  };

  // console.log(Object.keys(selectedInfo).length, "selectedInfo.length");

  useEffect(() => {
    function handleClickOutside(event) {
      // Check if the click is outside the suggestions container
      if (suggestionsRef.current && !suggestionsRef.current.contains(event.target)) {
        dispatch(setSuggestions([]));
        dispatch(setLocationInput(""));
      }
    }
    // Attach the event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Clean up the event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      dispatch(setSuggestions([]));
      dispatch(setLocationInput(""));
    };
  }, [dispatch]);




  return (
    <div

      className="  h-full flex flex-col justify-between"
    >
      {/* Header */}
      <div

        onClick={handleBackNavigation}
        className="flex    hover:bg-white hover:bg-opacity-20 py-2 my-1 gap-4 text-blackPrimaryText dark:text-darkModeBlackPrimaryText font-semibold px-2 cursor-pointer w-fit "
      >
        <img src={leftArrow} alt="Back" />
        <p>Manage Locations</p>
      </div>
      {/* Main Content */}
      <div className="flex flex-1   rounded-lg bg-primaryBgColor dark:bg-darkModePrimaryBgColor">
        <div className="lg:flex lg:flex-row w-full lg:h-full sm:h-screen ">
          {/* Left Section */}
          <div className="lg:flex flex-col   lg:px-5  my-4   sm:border-b lg:border-b-0  lg:border-r border-blackPrimaryText dark:border-darkModeBlackPrimaryText lg:w-[48%]   ">
            {/* Search Section */}
            <div className="flex flex-col     p-1 rounded-sm   relative">
              <div ref={suggestionsRef} className="flex flex-col h-full    ">
                <div className="flex justify-between  rounded-sm w-full p-1 gap-1">
                  <div className="flex flex-1 gap-3 bg-white bg-opacity-20 dark:bg-black dark:bg-opacity-20 border border-blackPrimaryText dark:border-darkModeBlackPrimaryText border-opacity-30 items-center pl-3 pr-2 py-1 rounded-lg shadow-inner focus-within:bg-opacity-30 transition-all">
                    <div>
                      <SearchLocation theme={theme} />
                    </div>
                    <input
                      className="outline-none bg-transparent placeholder:text-gray-500 font-medium dark:text-darkModeBlackPrimaryText text-blackPrimaryText w-full"
                      type="text"
                      disabled={mappedNewLocations.length >= 5}
                      value={locationInput}
                      onChange={handleInputChange}
                      placeholder="Search by village, state, or district"
                    />
                  </div>
                  <button
                    className={`bg-blackPrimaryText dark:bg-darkModeBlackPrimaryText font-semibold p-2 flex items-center rounded-md  dark:text-blackPrimaryText text-secondaryBgColor disabled:opacity-70 ${mappedNewLocations.length >= 5 ||
                      locationInput.length === 0
                      ? "cursor-not-allowed"
                      : "cursor-pointer"
                      } `}
                    data-tooltip-id="fav-location"
                    data-tooltip-place="bottom-end"
                    data-tooltip-variant="info"
                    disabled={
                      mappedNewLocations.length >= 5 ||
                      locationInput.length === 0 ||
                      Object.keys(selectedInfo).length === 0
                    }
                    onClick={() => addFavorateCity(selectedInfo)}
                  >
                    <p>Add location</p>
                    <div className="ml-2">
                      <Add_location theme={theme} />
                    </div>
                  </button>
                </div>
                <div


                  className="absolute top-[50px]  z-10  w-full"
                  style={{
                    background: "rgba(255, 255, 255, 0.1)",
                    boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.37)",
                    backdropFilter: "blur(29.5px)",
                    WebkitBackdropFilter: "blur(5.5px)",
                    // borderRadius: "10px",
                  }}

                >
                  {loading && (
                    <p className="p-1 rounded-md">Loading suggestions...</p>
                  )}
                  {error && <p className="text-red-800 font-semibold p-1">{error}</p>}
                  {suggestions.length > 0 && locationInput && (
                    <ul className="border border-blackPrimaryText dark:border-darkModeBlackPrimaryText cursor-pointer rounded-sm  max-h-[300px] overflow-y-auto  w-[100%] dark:text-darkModeBlackPrimaryText text-blackPrimaryText ">
                      {suggestions?.map((item, index) => (
                        <li
                          onClick={() => {
                            addNewLocation(
                              item.village,
                              item.district,
                              item.village_latitude[0],
                              item.village_longitude[0]
                            );
                            setSelectedInfo({
                              village: item.village,
                              district: item.district,
                              latitude: item.village_latitude[0],
                              longitude: item.village_longitude[0],
                            });
                          }}
                          key={index}
                          className="p-2 border-b border-blackPrimaryText dark:border-darkModeBlackPrimaryText hover:bg-primaryBgColor dark:bg-darkModePrimaryBgColor"
                        >
                          <strong>Village:</strong> {item.village?.[0] || "N/A"}
                          ,<strong> District:</strong>{" "}
                          {item.district?.[0] || "N/A"},<strong> State:</strong>{" "}
                          {item.state?.[0] || "N/A"}
                          <br />
                          <small>
                            Coordinates:{" "}
                            {item.village_latitude && item.village_longitude
                              ? `${item.village_latitude[0]}, ${item.village_longitude[0]}`
                              : "N/A"}
                          </small>
                        </li>
                      ))}
                    </ul>
                  )}
                  {!loading &&
                    !error &&
                    locationInput.length > 2 &&
                    suggestions.length === 0 && <p>No results found.</p>}
                </div>
              </div>
              {mappedNewLocations.length >= 5 && (
                <p className="italic text-red-500 font-semibold">
                  You can only add up to five locations.{" "}
                </p>
              )}

              <MetroPoliticianCities handleCity={handleCity} />

              {/* <img src={GoToMap} alt="Map" /> */}
            </div>

            {/* Suggestions */}
          </div>

          {/* Right Section */}
          <div className=" flex flex-col    my-4 sm:px-2  lg:px-5    lg:w-[48%]  sm:h-[80vh] lg:h-[90%]   bg-primaryBgColor dark:bg-darkModePrimaryBgColor">
            <p className="text-blackPrimaryText dark:text-darkModeBlackPrimaryText font-semibold text-center">
              My Favorite locations :
            </p>

            {mappedNewLocations.length === 0 && (
              <p className="italic text-blackPrimaryText dark:text-darkModeBlackPrimaryText font-semibold py-2 text-center">
                Add a location to favorites from the search{" "}
              </p>
            )}

            {/* Added locations will go here */}
            <div className="   max-h-[70vh]  ">
              {mappedNewLocations?.map((newLocation, index) => (
                <div
                  key={index}
                  // style={{
                  //   backgroundColor:
                  //     highlightedIndex === index ? "green" : "#F5F8FE",
                  // }}
                  className="cursor-pointer flex justify-between px-4 py-2 rounded-md my-3 bg-secondaryBgColor dark:bg-darkModeCardBgColor text-blackPrimaryText dark:text-darkModeBlackPrimaryText"
                >
                  <div
                    onClick={() => openModal(newLocation)}
                    className="flex flex-1 justify-between  "
                  >
                    <div className="flex flex-col">
                      <div className="flex gap-2">
                        <p className="font-semibold">{newLocation.vill},</p>
                        <p className="font-semibold">{newLocation.dist}</p>
                      </div>
                      <div className="flex gap-2">
                        <p className="text-sm">{newLocation.date}</p>
                        <p className="text-sm">{newLocation.time}</p>
                      </div>
                    </div>
                    <div className="flex flex-col text-right">
                      <p className="text-lg font-semibold text-blackPrimaryText dark:text-darkModeBlackPrimaryText">{`${Math.trunc(
                        newLocation.data
                      )} °C`}</p>
                      <p className="text-sm font-semibold">
                        {newLocation.title}
                      </p>
                    </div>
                  </div>
                  <button
                    onClick={() => handleRemoveNewLocations(index)}
                    className="ml-2"
                  >
                    <DeleteBox theme={theme} />
                    {/* <img src={DeleteBox} alt="DeleteBox" /> */}
                  </button>
                  <Modal
                    isOpen={isModalOpen}
                    onRequestClose={closeModal}
                    style={customStyles}
                  >
                    <div className="flex flex-col justify-between p-6 h-full items-center bg-white dark:bg-darkModeSecondaryBgColor rounded-xl border border-white dark:border-white dark:border-opacity-10 shadow-2xl space-y-6">
                      <p
                        ref={subtitleRef}
                        className="text-lg text-blackPrimaryText dark:text-darkModeBlackPrimaryText font-bold text-center leading-relaxed"
                      >
                        Do you want to set <span className="text-wsText dark:text-wsTextDark">{selectedLocation.vill}</span>,{" "}
                        <span className="text-wsText dark:text-wsTextDark">{selectedLocation.dist}</span> as your default location?
                      </p>
                      <div className="flex gap-4 w-full">
                        <button
                          onClick={() => addCurrentLocation(selectedLocation)}
                          className="flex-1 bg-wsText hover:bg-opacity-90 text-white py-3 px-6 rounded-lg shadow-lg font-extrabold transition-all transform active:scale-95 uppercase tracking-wider text-xs"
                        >
                          Confirm
                        </button>
                        <button
                          onClick={closeModal}
                          className="flex-1 bg-white dark:bg-white/5 text-gray-700 dark:text-gray-300 border border-gray-200 dark:border-gray-700 font-extrabold py-3 px-6 rounded-lg hover:bg-gray-50 transition-all uppercase tracking-wider text-xs"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </Modal>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Toaster />
      <Tooltip id="fav-location" />
    </div>
  );
};

export default ManageLocations;
